// Supermove
import {gql} from '@supermove/graphql';
import {JobModel} from '@supermove/models';
import {Datetime, withFragment} from '@supermove/utils';

export interface JobStartTimesFormFields {
  jobId: string;
  startTime1: string;
  startTime2: string;
}

const edit = withFragment(
  (job: JobModel): JobStartTimesFormFields => ({
    jobId: job.id,
    startTime1: Datetime.toFormTime(job.startTime1),
    startTime2: Datetime.toFormTime(job.startTime2),
  }),
  gql`
    fragment JobStartTimesForm_edit on Job {
      id
      startTime1
      startTime2
    }
  `,
);

const toMutation = ({jobId, startTime1, startTime2}: JobStartTimesFormFields) => ({
  jobId,
  startTime1: Datetime.toMutationTime(startTime1),
  startTime2: Datetime.toMutationTime(startTime2),
});

const JobStartTimesForm = {
  edit,
  toMutation,
};

export default JobStartTimesForm;
